// extracted by mini-css-extract-plugin
export default {"root":"NestedLinksButton_root__SXScz","label":"NestedLinksButton_label__bRaBo","icon":"NestedLinksButton_icon__hQqMu"};